<template>
  <footer id="footer" class="footer">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-12">
          <div class="logo-footer" id="logo-footer">
            <router-link to="/">
              <img id="logo_footer" alt="" :src="getImageUrl(contact.logo)" />
            </router-link>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-left">
            <div class="footer-title" style="text-transform: uppercase">
              {{ $t("we_are_here") }}
            </div>
            <p style="padding-right: 25%">
              {{ contact.address }}, {{ contact.city }}, {{ contact.country
              }}<br />
              {{ contact.shop_email }} <br />
              {{ contact.phone }}
            </p>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-center">
            <p>
              {{ contact.small_description }}
            </p>
            <div class="widget-social-text">
              <ul class="flex-wrap">
                <li v-if="contact.facebook != null">
                  <a
                    :href="contact.facebook"
                    target="_blank"
                    rel="noopener noreferrer"
                    >Facebook</a
                  >
                </li>
                <li v-if="contact.instagram != null">
                  <a
                    :href="contact.instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                    >instagram</a
                  >
                </li>
                <li v-if="contact.linkedIn != null">
                  <a
                    :href="contact.linkedIn"
                    target="_blank"
                    rel="noopener noreferrer"
                    >linkedIn</a
                  >
                </li>
                <li v-if="contact.tikTok != null">
                  <a
                    :href="contact.tikTok"
                    target="_blank"
                    rel="noopener noreferrer"
                    >tiktok</a
                  >
                </li>
                <li v-if="contact.twitter != null">
                  <a
                    :href="contact.twitter"
                    target="_blank"
                    rel="noopener noreferrer"
                    >twitter</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-right">
            <div
              class="footer-title opening-hour"
              style="text-transform: uppercase"
            >
              {{ $t("opening_time") }}
            </div>
            <p style="padding-left: 25%">
              {{ $t("monday") }} - {{ $t("sunday") }}:
              {{ openHour.open_time_hours_from }} -
              {{ openHour.open_time_hours_to }} | <br />
              {{ $t("delivery") }}: {{ openHour.delivery_time_from }} -
              {{ openHour.delivery_time_to }}
            </p>
          </div>
        </div>
        <div class="col-12">
          <div class="footer-bottom">
            <p>© {{ new Date().getFullYear() }} {{ contact.shop_name }}</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import axios from "axios";
import { langStore } from "../../../langStore";

export default {
  name: "FooterComponent",
  props: {
    msg: String,
  },

  data() {
    return {
      langStore,
      contact: {},
      openHour: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchFooter();
    },
  },

  mounted() {
    this.fetchFooter();
  },

  methods: {
    fetchFooter() {
      axios
        .get(`${process.env.VUE_APP_BASE_URL}/api/setting`, {
          params: { lang: this.langStore.lang },
        })
        .then((response) => {
          this.contact = response.data;
        })
        .catch((error) => {
          console.error("There was an error fetching the data:", error);
        });

      axios
        .get(`${process.env.VUE_APP_BASE_URL}/api/open-hour`, {
          params: { lang: this.langStore.lang },
        })
        .then((response) => {
          this.openHour = response.data;
        })
        .catch((error) => {
          console.error("There was an error fetching the data:", error);
        });
    },
    getImageUrl(photo) {
      const baseUrl = `${process.env.VUE_APP_BASE_URL}/uploads/`;
      return baseUrl + photo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
